<div class="splash" [@Fade]="'in'">
  <img [src]="'/assets/images/logo.svg'" alt="Straatvinken">
  <div class="splash-spaced" [hidden]="!loaded">
    <p>in samenwerking met</p>
    <img [src]="'/assets/images/logo-spaced.svg'" (load)="imageLoaded()" alt="Spaced">
  </div>
</div>